export function initScrollReveal() {
  if (typeof IntersectionObserver === 'undefined') return;
  const _revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
        _revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  const _observeReveals = () => {
    document.querySelectorAll('.reveal:not(.revealed)').forEach(el => {
      _revealObserver.observe(el);
    });
  };

  setInterval(_observeReveals, 500);
}
